/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  serviceId: ZodTypes.Id,
});

export const DeleteDismissedAdvices = {
  id: 'dismissed-advices.delete',
  tag: 'Advice',
  summary: 'Clear all dismissed advice',
  description: 'Clears all dismissed advice of a cluster',
  method: 'delete',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.serviceId}/dismissed-advice`,
  request: { params: Params },
  response: { 200: { description: 'successful', content: { 'application/json': { schema: z.string().optional() } } } },
} as const satisfies Endpoint;
